import { call, put, takeLatest } from 'redux-saga/effects';
import { API } from '../api';
import {
  FETCH_CHARGER_LOG,
  FETCH_CHARGER_LOG_SUCCESS,
  FETCH_CHARGER_LOG_FAIL,
  DELETE_CHARGER_LOG_SUCCESS,
  DELETE_CHARGER_LOG_FAIL,
  DELETE_CHARGER_LOG,
  DOWNLOAD_CHARGER_LOG_DATA,
  DOWNLOAD_CHARGER_LOG_DATA_SUCCESS,
  DOWNLOAD_CHARGER_LOG_DATA_FAIL,
} from 'actions/activityLog';

function* fetchActivityLog(action) {
  try {
    const response = yield call(API.getActivityLog, action.payload);
    yield put({ type: FETCH_CHARGER_LOG_SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: FETCH_CHARGER_LOG_FAIL, payload: { error: e } });
    action.cb && action.cb(e);
  }
}

function* deleteActivityLog(action) {
  try {
    yield call(API.deleteActivityLog, action.payload);
    yield put({ type: DELETE_CHARGER_LOG_SUCCESS, payload: action.payload });
  } catch (e) {
    yield put({ type: DELETE_CHARGER_LOG_FAIL, payload: { error: e } });
  }
}

function* downloadChargerLog(action) {
  try {
    const response = yield call(API.downloadChargerLogData, action.payload);
    yield put({ type: DOWNLOAD_CHARGER_LOG_DATA_SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: DOWNLOAD_CHARGER_LOG_DATA_FAIL, payload: { error: e } });
    action.cb && action.cb(e);
  }
}

function* activityLog() {
  yield takeLatest(FETCH_CHARGER_LOG, fetchActivityLog);
  yield takeLatest(DELETE_CHARGER_LOG, deleteActivityLog);
  yield takeLatest(DOWNLOAD_CHARGER_LOG_DATA, downloadChargerLog);
}
export default activityLog;
